import { render, staticRenderFns } from "./main.terceros.vue?vue&type=template&id=64a53514"
import script from "./main.terceros.vue?vue&type=script&lang=js"
export * from "./main.terceros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports